import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";
import {Attribute} from "./attribute";
import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";

// use custom types for selected columns and js code to be able
// to automate detection. e.g. in backend

interface ProductAttributeConfiguration {
    /**
     * @title Attribute for rating
     */
    attribute?: Attribute;
}

interface ReviewsAttributeConfiguration {
    /**
     * @title Attribute for reviews count
     */
    attribute?: Attribute;
}

/**
 * @description How many stars should represent the rating
 */
interface RatingRangeConfiguration {
    /**
     * @title From
     * @minimum 0
     * @maximum 50
     */
    min?: number;
    /**
     * @title To
     * @minimum 0
     * @maximum 50
     */
    max?: number;
}

interface ProductRatingConfigurationInterface {
    /**
     * @title Show product rating
     * @description If enabled, the product rating is displayed as stars by the product name
     */
    enabled: boolean;
    range: RatingRangeConfiguration;
    rating?: ProductAttributeConfiguration;
    reviews?: ReviewsAttributeConfiguration;
}

/**
 * @title Product Rating Configuration
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.ProductRating)
@ComponentConfigurationClass("productRating")
export class ProductRatingConfiguration {
    /**
     * @format custom-product-rating-configuration
     */
    public showProductRating?: ProductRatingConfigurationInterface;
}
